import Button from '@mui/material/Button';
import theme from '../theme';

export default function Footer() {
    return (
        <footer className='bg-[#333333] text-[#ffffff] text-center p-7 fixed bottom-0 w-full'>
            <p style={{fontFamily: theme.typography.main_en.fontFamily}} className='text-sm'>©
                <span className='mx-[0.5em]'>
                    <a href="/" className='underline decoration-1'>
                        TONPEKE
                    </a>
                </span> ALL Right Reserved.</p>
        </footer>
    );
}